import { Fragment, useReducer, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { userActions } from "../store/user-slice";
import useFetch from './../hook/useFetch';
import { notificationActions } from "../store/notification-slice";

export default function Login() {

    let componentReducer = (state, action) => {

        switch (action.type) {
            case 'email':
                return { ...state, email: action.data }
            case 'password':
                return { ...state, password: action.data }
            case 'showpassform':
                return { ...state, showresetpassform: !state.showresetpassform }

        }

    }

    const [componentState, componentDispatch] = useReducer(componentReducer, {
        email: null,
        password: null,
        showresetpassform: false
    })

    let dispatch = useDispatch()

    const { error, update ,post} = useFetch()

    let navigate = useNavigate()

    let resetpassemail = useRef()



    return <div className="login-container" >
        <form className="login-form shadow" onSubmit={(e) => {
            e.preventDefault()

            update('/user/login', {
                email: componentState.email,
                password: componentState.password,

            }, null, (data) => {

                dispatch(userActions.setUser(data))
                dispatch(userActions.setToken(data.token))
                navigate('/')
            })
        }} >

            {error &&
                <div className="alert bg-danger " >
                    <p>{error}</p>
                </div>
            }

            <div className="form-group">
                <label>Email address</label>
                <input type="email" className="form-control" placeholder="Email" defaultValue={componentState.email} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'email',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label>Password</label>
                <input type="password" className="form-control" placeholder="Password" defaultValue={componentState.password} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'password',
                            data: e.target.value
                        }
                    )
                }} required />
            </div>

            <button type="submit" className="btn btn-primary" >Login</button>
            <a className="btn" href="#" onClick={(e) => {
                e.preventDefault()
                componentDispatch({
                    type: 'showpassform'
                })
            }} >Forgot password?</a>

              {componentState.showresetpassform &&
                
                   <Fragment>
                    
                     <label>Enter your email,reset link will be sent to you by email</label>
                    <input type="email" className="form-control" placeholder="Email" ref={resetpassemail}  />
                    <button className="btn btn-secondary" type="button" onClick={()=>{
                       if(!resetpassemail.current.value){
                        return
                       }

                       post(`/user/reset-request?email=${resetpassemail.current.value}&redirect=${process.env.REACT_APP_BASE_URL}`, null, null, (data) => {
                        componentDispatch({
                            type: 'showpassform'
                        })
                        dispatch(notificationActions.setNotification({
                            message:data,
                            status:true
                        }))

                    })
                       
                    }} >SendLink</button>
                   </Fragment>
                
            }
           
            <Link className="btn" to='/signup' >Register</Link>
        </form>

      
        
    </div>

}


